<template>

  <list-modal-detail
    v-if="form"
    :form="form"
    :control-name="controlName"
    :controller="controller"
    :has-mutations.sync="hasMutations"
    :authorize-create="authorizeCreate"
    :authorize-update="authorizeUpdate"
    :authorize-delete="authorizeDelete"
    :page-title="pageTitle"
    :dataSource="dataSource"
    :fetchDestination="fetchDestination">
    <template>
      
      <div class="row">
        <div class="col">
          <form-wrapper v-for="item in formItems" :form-config="item" :key="item.formTag" />
        </div>
      </div>

    </template>
  </list-modal-detail>

</template>

<script>
import ListModalDetail from 'components/Templates/ListModalDetail.vue';
import formmixin from '@/forms/components.js';
import { CreateForm } from '@/libs/classes/specifications';

export default {
  props: {
    controlName: {
      required: true
    },
    controller: {
      required: true
    },
    authorizeCreate: {
      default: () => []
    },
    authorizeUpdate: {
      default: () => []
    },
    authorizeDelete: {
      default: () => []
    },
    pageTitle: {
      default: ''
    },
    dataSource: {
      default: () => []
    },
    fetchDestination: { }
    
  },
  mixins: [formmixin],
  components: {
    'list-modal-detail': ListModalDetail,
  },
  data () {
    return {
      form: null,
      formItems: null,
      formProps: null,
      hasMutations: false
    };
  },
  async mounted () {
    this.formProps = CreateForm(await this.controller.GetForm());
    this.form = this.formProps.form;
    this.formItems = this.form.config;
  },
  methods: {
  }
};
</script>
